
import { GiftshopProduct, GiftshopVariant } from '@/models/Giftshop';

import { Component, Prop, Vue } from 'vue-property-decorator';
import GiftshopSelectionModalProductImages from './GiftshopSelectionModalProductImages.vue';
import GiftshopSelectionModalProductVariants from './GiftshopSelectionModalProductVariants.vue';

@Component({
    name: 'GiftshopSelectionModalProduct',
    components: {
        GiftshopSelectionModalProductImages,
        GiftshopSelectionModalProductVariants,
    }
})
export default class GiftshopSelectionModalProduct extends Vue {
    @Prop({ type: Object, required: true }) product: GiftshopProduct;
    @Prop({ type: Boolean, required: false, default: false }) previewOnly: boolean;

    selectedVariant: GiftshopVariant = null;
    selectedVariantDimension1: string = null;

    get selectedProduct(): string {
        return this.selectedVariant?.id ?? this.product.id;
    }

    get name(): string {
        return this.selectedVariant?.name ?? this.product.name;
    }

    get shortDescription(): string {
        if (this.selectedVariant?.shortdescription || this.selectedVariant?.longdescription)
            return this.selectedVariant?.shortdescription;
        
        return this.product.shortdescription;
    }

    get longDescription(): string {
        if (this.selectedVariant?.shortdescription || this.selectedVariant?.longdescription)
            return this.selectedVariant?.longdescription;

        return this.product.longdescription;
    }

    handleSelectVariant(variant: GiftshopVariant) {
        this.selectedVariant = variant;
    }

    handleSelectVariantDimension1(dim1: string) {
        this.selectedVariantDimension1 = dim1;
        this.handleSelectVariant(this.product.variants?.filter(o => o.dimension1code == dim1)?.[0] ?? null);
    }

    handleSelect() {
        this.$emit('select', { product: this.product, variant: this.selectedVariant ?? null });
    }

    created() {
        this.handleSelectVariant(this.product.variants?.[0] ?? null);
        this.handleSelectVariantDimension1(this.product.variants?.[0]?.dimension1code ?? null);
    }
}
